module.exports = __webpack_public_path__ + "img/icon-const-norm-bg-3.e9f6e5f3.png";